import { render } from "./AuthForm.vue?vue&type=template&id=2ef4b55c&lang=pug"
import script from "./AuthForm.vue?vue&type=script&lang=js"
export * from "./AuthForm.vue?vue&type=script&lang=js"

import exportComponent from "/Users/sellerofhappiness/WORK/VUE/CORAL VUE/components-store-v2/AUTH-FORM-CARD/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__